import type { BaseEventMetrics } from '@schibsted/pulse-news-media/lib/types/types';
import type { BlenderPersonalization } from '../../../data-sources/frapi/types.js';
import type { PulseAttributes } from '../../../../../public-src/core/js/pulse/pulse-util.js';

type GetBlendMetricsReturn =
  | [
      {
        source: 'Curate';
        name: 'personalizedResults';
        key: string;
        value: number;
      },
      {
        source: 'Curate';
        name: 'removeImpressed';
        key: string;
        value: number;
      },
      {
        source: 'Curate';
        name: 'removeRead';
        key: string;
        value: number;
      },
    ]
  | [];

const generateTeaserMetrics = (
  blendId: string,
  pulseMeta: PulseAttributes,
): BaseEventMetrics => {
  const hasPersonalizationScore = pulseMeta.hasPersonalizationScore;
  const seenCount = pulseMeta.seenCount;
  const hasBeenRead = pulseMeta.hasBeenRead;

  return [
    {
      source: 'Curate',
      name: 'personalizedResults',
      key: blendId,
      value: hasPersonalizationScore,
    },
    {
      source: 'Curate',
      name: 'removeImpressed',
      key: blendId,
      value: seenCount,
    },
    {
      source: 'Curate',
      name: 'removeRead',
      key: blendId,
      value: hasBeenRead,
    },
  ];
};

const getTeaserMetrics = (
  blendId: string | undefined,
  pulseMeta: PulseAttributes,
): BaseEventMetrics => {
  return blendId &&
    (pulseMeta.entityType === 'ARTICLE' || pulseMeta.entityType === 'Teaser') &&
    /* check source to exclude teasers in widgets */
    pulseMeta.source?.includes('frontpage')
    ? generateTeaserMetrics(blendId, pulseMeta)
    : [];
};

const getBlendMetrics = (
  blendId: string | undefined,
  personalization: BlenderPersonalization | undefined | null,
): GetBlendMetricsReturn => {
  if (!blendId) return [];

  return [
    {
      source: 'Curate',
      name: 'personalizedResults',
      key: blendId,
      value: personalization?.personalizedResults ?? 0,
    },
    {
      source: 'Curate',
      name: 'removeImpressed',
      key: blendId,
      value: personalization?.removeOnImpressed ?? 0,
    },
    {
      source: 'Curate',
      name: 'removeRead',
      key: blendId,
      value: personalization?.removeOnRead ?? 0,
    },
  ];
};

export { getTeaserMetrics, getBlendMetrics };
